<script setup lang="ts">
  import type { PlanPaymentMethod, SubscriptionAttempt } from '@/types'
  import { PAYMENT_METHODS, SUP_PAYMENT_METHODS } from '@/enum/payments.ts'

  defineOptions({
    inheritAttrs: false,
  })

  const { planPaymentMethod } = defineProps<{
    planPaymentMethod: PlanPaymentMethod
  }>()

  const emit = defineEmits<{
    'open-plan-list': [],
    'payment-error': [error: unknown]
    'payment-completed': [attempt: SubscriptionAttempt, paymentResponse: Record<string, unknown>]
  }>()


  const showDirectForm = computed(() => {
    if ([PAYMENT_METHODS.tamatem, PAYMENT_METHODS.free, PAYMENT_METHODS.paymob].includes(planPaymentMethod.payment_method_id as never)) {
      return true
    }
    // checkout apple pay, google pay, paypal to show the payment form directly
    if ([SUP_PAYMENT_METHODS.applePay, SUP_PAYMENT_METHODS.googlePay, SUP_PAYMENT_METHODS.paypal].includes(planPaymentMethod.sub_payment_method_id as never)) {
      return true
    }
    return false
  })

  const showIcon = computed(() => {
    if ([PAYMENT_METHODS.idex, PAYMENT_METHODS.tpay, PAYMENT_METHODS.tamatem, PAYMENT_METHODS.paymob].includes(planPaymentMethod.payment_method_id as never)) {
      return true
    }
    // checkout credit card to show the icon
    if ([SUP_PAYMENT_METHODS.card].includes(planPaymentMethod.sub_payment_method_id as never)) {
      return true
    }
    return false
  })

</script>

<template>
  <div v-if="showIcon" class="d-flex flex-column ga-2 align-center justify-space-between mt-4 mb-6">
    <span class="text-grey-400">
      <i18n-t keypath="featured_payment_method_pay_using" />
    </span>

    <span>
      <v-img
        :alt="planPaymentMethod.sub_payment_method!.name!"
        contain
        height="20"
        max-width="100"
        :src="planPaymentMethod.sub_payment_method!.media?.url"
        width="auto"
      />
    </span>
  </div>

  <div>
    <payment-form
      v-if="showDirectForm"
      :plan-payment-method="planPaymentMethod"
      @payment-completed="(attempt: SubscriptionAttempt, paymentResponse: Record<string, unknown>) => emit('payment-completed', attempt, paymentResponse)"
      @payment-error="(error: unknown) => emit('payment-error', error)"
    />
    <v-btn
      v-else
      block
      class="text-subtitle-1 font-weight-bold"
      color="primary"
      size="large"
      variant="flat"
      @click="emit('open-plan-list')"
    >
      <i18n-t :keypath="'subscribe_btn_' + planPaymentMethod.sub_payment_method_id" />
    </v-btn>
  </div>
</template>

<style scoped lang="scss">

</style>
